const it = {
  minimumValue: 'Valore minimo',
  search: 'Cerca...',
  goToCheckout: 'Vai al checkout',
  pleaseWait: 'Attendere prego...',
  orderCreatedSuccessfully: 'Ordine creato con successo!',
  checkout: 'Checkout',
  addressDetails: 'Dettagli indirizzo',
  phoneNumber: "Numero di telefono",
  orderDetails: "Dettagli ordine",
  paymentMethod: "Metodo di pagamento",
  cash: "Contanti",
  subtotal: "Subtotale",
  deliveryCharge: "Spese di consegna",
  total: "Totale",
  verificationCodeWasNotCorrect: "Il codice di verifica non era corretto",
  confirmationCode: "Codice di conferma",
  enterThe4DigitCodeThatWeSentViaSMS: "Inserisci il codice a 4 cifre che ti abbiamo inviato via SMS",
  close: "Chiudi",
  enterAddress: "Inserisci indirizzo",
  enterYourDesiredDeliveryAddress: "Inserisci l'indirizzo di consegna desiderato",
  youNeedADeliveryAddressToProceed: "È necessario un indirizzo di consegna per procedere",
  setAddress: "Imposta indirizzo",
  allowLocationPermissionToBrowserFromMobileSettingsForThisFunctionality: "Consenti l'accesso alla posizione al browser dalle impostazioni del cellulare per questa funzionalità",
  geolocationIsNotSupportedInThisBrowser: "La geolocalizzazione non è supportata in questo browser",
  searchAddress: "Cerca indirizzo",
  deliveryAddress: "Indirizzo di consegna",
  weAreNotAbleToCompleteYourOrderProcess: "Non siamo in grado di completare il processo dell'ordine",
  pleaseTryAgainWhenServiceIsSupported: "Riprova quando il servizio è supportato.",
  thankYouForYourOrder: "Grazie per il tuo ordine",
  invoiceDate: "Data fattura",
  accepted: "Accettato",
  cancelled: "Annullato",
  requested: "Richiesto",
  delivering: "In consegna",
  paymentInProgress: "Pagamento in corso",
  waitingForConfirmation: "In attesa di conferma",
  orderId: "ID ordine",
  restaurant: "Ristorante",
  address: "Indirizzo",
  orderAgain: "Ordina di nuovo",
  openHours: "Orari di apertura",
  placeYourOrder: "Effettua il tuo ordine",
  errors: {
    empty_delivery_address: "L'indirizzo di consegna non può essere vuoto",
    empty_phone_number: "Il numero di telefono non può essere vuoto",
    invalid_phone_number: "Numero di telefono non valido"
  },
  table: "Tavolo",
  refresh: "Aggiorna",
  inOrderToCheckAvailabilityOfFunctionalityAndProceedWithMenu: "Per verificare la disponibilità della funzionalità e procedere con il menu",
  weWereNotAbleToCompleteYourOrderProcess: "Non siamo riusciti a completare il processo dell'ordine",
  clientMustBeInsideDefinedZones: "Il cliente deve trovarsi all'interno delle zone definite",
  pleaseTryAgainWhenVisitingOurBusiness: "Riprova quando visiti la nostra attività",
  theProvidedQrIsInvalid: "Il QR fornito non è valido",
  leaveAReview: 'Lascia una recensione'
};

export default it;